import React from 'react'
import { useDispatch } from 'react-redux'
import { STATICS } from 'statics'
import { setDrawer, setData, setStage } from 'slices/drawer'
import { DRAWER_KEY, FAQ_CATEGORIES, FAQ_STAGES } from 'app-constants'
import './style.scss'

export function RecurringPayment() {
  const dispatch = useDispatch()

  function handleClick() {
    dispatch(setData({ faqInitialCategory: FAQ_CATEGORIES.PAYMENT }))
    dispatch(setDrawer(DRAWER_KEY.FAQ))
    dispatch(setStage(FAQ_STAGES.CATEGORY))
  }

  return (
    <div className='container-recurring-payment'>
      <div className='container-icon'>
        <STATICS.CYCLE />
      </div>
      <div className='container-text'>
        <span className='title'>Seu pagamento recorrente está ativo</span>
        <span className='text'>
          Sua fatura será debitada automaticamente na data de vencimento do meio de pagamento
          escolhido.{' '}
          <button type='button' className='button' onClick={handleClick}>
            Saiba mais.
          </button>
        </span>
      </div>
    </div>
  )
}
